import { globalApiHandler } from "../../services/services";
import { formatDate } from "../../utils/DateFormatter";

export const COMMODITY = {
  getAllCommList: {
    success: "COMMODITY_GET_ALL_SUCCESS",
    error: "COMMODITY_GET_ALL_ERROR"
  },
  create: {
    success: "COMMODITY_CREATE_SUCCESS",
    error: "COMMODITY_CREATE_ERROR"
  },
  edit: {
    success: "COMMODITY_EDIT_SUCCESS",
    error: "COMMODITY_EDIT_ERROR"
  },
  update: {
    success: "COMMODITY_UPDATE_SUCCESS",
    error: "COMMODITY_UPDATE_ERROR"
  },
  delete: {
    success: "COMMODITY_DELETE_SUCCESS",
    error: "COMMODITY_DELETE_ERROR"
  }
};

export const commodityListAction = () => {
  let url = `/ntrac/commodity/commodityList`;
  return dispatch => {
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data.data;
        data.map(item => {
          item.updatedAt = formatDate(item.updatedAt);
        });
        dispatch({ type: COMMODITY.getAllCommList.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const createCommodityAction = commodityInfo => {
  let url = `/ntrac/commodity`;
  return dispatch => {
    globalApiHandler(url, "post", commodityInfo)
      .then(response => {
        dispatch({ type: COMMODITY.create.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const editCommodityAction = data => {
  return dispatch => {
    dispatch({ type: COMMODITY.edit.success, data });
  };
};

export const updateCommodityAction = commodityInfo => {
  let url = `/ntrac/commodity/${commodityInfo.id}`;
  return dispatch => {
    globalApiHandler(url, "put", commodityInfo)
      .then(response => {
        dispatch({ type: COMMODITY.update.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const deleteCommAction = id => {
  let url = `/ntrac/commodity/${id}`;
  return dispatch => {
    globalApiHandler(url, "delete", {})
      .then(response => {
        const data = response.data.data;
        dispatch({ type: COMMODITY.delete.success, data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/commodities/action.js